export enum DatePickerRestrictionDateType {
  Today = 'today',
}
